import React from 'react'
import { MdInfoOutline, MdOutlineClose } from 'react-icons/md'

const DeleteModal = ({
    isOpen,
    handleCandle,
    handleDelete,
}) => {

    return (
        <div id="popup-modal" tabIndex="-1" className={`${isOpen ? "flex" : "hidden"} overflow-y-auto fixed inset-0 z-50 justify-center items-center bg-gray-900 bg-opacity-50`}>
            <div className="relative p-4 w-full max-w-md md:max-w-lg max-h-full">
                <div className="relative bg-white rounded-lg shadow-lg">
                    <button type="button" className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center" data-modal-hide="popup-modal" onClick={handleCandle}>
                        <MdOutlineClose className='text-2xl' />
                        <span className="sr-only">Close modal</span>
                    </button>
                    <div className="p-4 md:p-5 text-center">
                        <MdInfoOutline className='text-6xl text-gray-400 mx-auto mb-4' />
                        <h3 className="mb-5 text-lg font-normal text-gray-500">Are you sure you want to delete this item?</h3>
                        <button data-modal-hide="popup-modal" type="button" className="text-white bg-red-500 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center" onClick={handleDelete}>
                            Yes, I'm sure
                        </button>
                        <button data-modal-hide="popup-modal" type="button" className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100" onClick={handleCandle}>No, cancel</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeleteModal

